/* eslint-disable */
// import requestRaw from '@/utils/requestRaw'
import requestRawApi from '@/utils/requestRawApi'
import { APICore } from '@/utils/servicesApi'
// const qs = require('qs')
// console.log("requestRaw",requestRaw)
export function pickOperatorBySlug(data) {
    return requestRawApi({
        url: APICore() + '/public/link-generator/pick-operator-byslug',
        method: 'POST',
        data: data // untuk array data post
    })
}


// WEBPACK FOOTER //
// ./src/api/toolkit.js